/* eslint-disable you-dont-need-momentjs/is-same */
/* eslint-disable you-dont-need-momentjs/no-moment-constructor */
/* eslint-disable you-dont-need-momentjs/format */
/* eslint-disable you-dont-need-momentjs/is-before */
/* eslint-disable no-param-reassign */
import moment from 'moment'
import { combineReducers } from 'redux'

import { addDaysToDate, LAUNCH_TIME_FORMAT, WIZARD_DATE_FORMAT } from 'utils/dateUtils'
import { required as requiredValidation } from 'utils/validations'

import {
  CAMPAIGN_TYPES_VALUES,
  DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
  DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  PARTICIPANTS_GROUP_KEYS,
} from 'containers/AwarenessCenter/constants'

import {
  CHANGE_CLOSE_TIME,
  CHANGE_DEFAULT_LOCALE_ID,
  CHANGE_PARTICIPANTS_SELECTION,
  CHANGE_PARTICIPANTS_TOTAL_SELECTION,
  GET_CAMPAIGN_ASYNC,
  REORDER_PLAYLIST_VIDEO_ASYNC,
  RESET_CAMPAIGN_TYPE_FLAGS,
  SET_PLAYLIST_MODE_ASYNC,
  TOGGLE_TRAINING_VIDEO,
} from '../steps/constants'
import { GET_EMAIL_PREVIEW_ASYNC } from '../steps/MessageStep/constants'
import messageStepReducer from '../steps/MessageStep/reducer'
import { wizardHandlers } from '../steps/reducer'
import reviewAndLaunchStepReducer from '../steps/ReviewAndLaunchStep/reducer'
import { GET_PARTICIPANTS_ASYNC, VALIDATE_SETUP_STEP } from '../steps/SetupStep/constants'
import setupStepReducer from '../steps/SetupStep/reducer'
import {
  AUTOMATED_LEVEL_BASED_TRAINING,
  CUSTOM_MODULE_IMAGE_PREVIEW,
  CUSTOM_MODULE_NAME_FILE,
  CUSTOM_MODULE_NAME_URL,
  CUSTOM_MODULE_TYPES,
  SOURCE_VALUES,
  TRAINING_VIDEO_TYPES,
} from '../steps/TrainingModuleStep/constants'
import trainingModuleStepReducer from '../steps/TrainingModuleStep/reducer'
import { mapCompletionNotificationSettingsFromApi } from '../steps/utils'

import {
  CHANGE_MESSAGE_STEP_PROPERTY,
  DEFAULT_COLLECTION_PERIOD,
  DEFAULT_TRAINING_CAMPAIGN_OBJECT,
  GET_DEFAULT_TRAINING_DATA_ASYNC,
  SYNC_PLAYLIST_ASSIGNMENT_ASYNC,
  SYNC_PLAYLIST_REMINDERS_ASYNC,
  TOGGLE_SAVE_MAIL_SIGNATURE,
  VALIDATE_MESSAGE_STEP_FIELDS,
} from './constants'
import {
  movePlaylistVideo,
  PLAYLIST_MODES,
  replaceUneditedMessage,
  replaceUneditedReminders,
  switchPlaylistMode,
  togglePlaylistVideo,
} from './playlist'
import { getTrainingCampaignLaunchProperties, mapTrainingValidatorByName } from './utils'

const handlers = {
  [VALIDATE_SETUP_STEP]: (state) => ({
    ...state,
    validation: {
      ...state.validation,
      name: mapTrainingValidatorByName.name(state.campaign.name),
      launchDate: mapTrainingValidatorByName.launchDate(state.campaign.launchDate),
      closeTime: mapTrainingValidatorByName.closeTime(
        state.campaign.closeTime,
        state.campaign.launchDate
      ),
      launchTime: mapTrainingValidatorByName.launchTime(
        state.campaign.launchTime,
        state.campaign.launchDate,
        state.campaign.timezone,
        state.campaign.randomized
      ),
    },
  }),
  [CHANGE_DEFAULT_LOCALE_ID]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      defaultLocaleId: payload.value,
      selectedTrainingVideo: [],
      otherModeSelection: [],
    },
  }),
  [RESET_CAMPAIGN_TYPE_FLAGS]: (state) => ({
    ...state,
    editMode: false,
  }),
  [CHANGE_PARTICIPANTS_SELECTION]: (state, { payload }) => {
    const participantsData = {
      ...state.campaign.participants,
      selectorLoader: true,
    }

    if (
      payload.key === PARTICIPANTS_GROUP_KEYS.INCLUDED &&
      Object.values(payload.value).length === 0
    ) {
      // cleared selected, clear also excluded
      participantsData.excluded = {}
      participantsData.meta = {
        count: 0,
      }
    }

    participantsData[payload.key] = payload.value

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedLandingPage: {},
        selectedTrainingVideo: [],
        otherModeSelection: [],
        participants: participantsData,
      },
    }
  },
  [CHANGE_PARTICIPANTS_TOTAL_SELECTION]: (state, { payload }) => {
    const participantsData = {
      ...state.campaign.participants,
      selectorLoader: true,
    }

    if (Object.values(payload.data.included).length === 0) {
      // cleared selected, clear also excluded
      participantsData.excluded = {}
      participantsData.meta = {
        count: 0,
      }
    } else {
      participantsData.excluded = payload.data.excluded
    }

    participantsData.included = payload.data.included

    return {
      ...state,
      campaign: {
        ...state.campaign,
        selectedLandingPage: {},
        selectedTrainingVideo: [],
        otherModeSelection: [],
        participants: participantsData,
      },
    }
  },
  [GET_PARTICIPANTS_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    loader: false,
    campaign: {
      ...state.campaign,
      participants: {
        ...state.campaign.participants,
        selectorLoader: false,
        modalLoader: false,
        error: null,
        items: payload.data.items,
        meta: {
          count: payload.data.meta.count,
        },
      },
    },
  }),
  [CHANGE_CLOSE_TIME]: (state, { payload }) => {
    const campaignLaunchProperties = getTrainingCampaignLaunchProperties(state, {
      closeTime: payload.value,
    })
    return {
      ...state,
      campaign: {
        ...state.campaign,
        ...campaignLaunchProperties,
      },
      validation: {
        ...state.validation,
        closeTime: mapTrainingValidatorByName.closeTime(
          campaignLaunchProperties.closeTime,
          campaignLaunchProperties.launchDate
        ),
      },
    }
  },
  [GET_CAMPAIGN_ASYNC.SUCCESS]: (state, { payload }) => {
    // A playlist keeps its deleted slots so the withdrawn video can be flagged.
    const isPlaylist = payload.data.is_playlist
    const trainings = isPlaylist
      ? payload.data.trainings
      : payload.data.trainings.filter((training) => !training.is_deleted)

    const name = payload.data.name
    const randomized = payload.data.randomized
    const launchDate = moment(payload.data.schedule_time).format(WIZARD_DATE_FORMAT)
    const launchTime = randomized
      ? ''
      : moment(payload.data.schedule_time).format(LAUNCH_TIME_FORMAT)
    let closeTime = moment(payload.data.close_time).format(WIZARD_DATE_FORMAT)
    const timezone = payload.data.campaign_timezone
    const isCloseBeforeLaunch = moment(closeTime).isBefore(moment(launchDate))
    let selectedTrainingVideo = []

    if (isCloseBeforeLaunch) {
      closeTime = addDaysToDate(launchDate, DEFAULT_COLLECTION_PERIOD, true)
    }

    if (trainings.length) {
      selectedTrainingVideo = trainings
      selectedTrainingVideo = selectedTrainingVideo.map((video, index) => {
        const videoName =
          video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
            ? video.items[0]?.custom_type === CUSTOM_MODULE_TYPES.CUSTOM_VIDEO
              ? CUSTOM_MODULE_NAME_FILE
              : CUSTOM_MODULE_NAME_URL
            : video.name

        return {
          ...video,
          ...(video.is_deleted && { id: `deleted-${index}` }),
          name: videoName,
          vendor: video.is_deleted ? video.vendor : video.vendor || SOURCE_VALUES.CUSTOM_MODULE,
          items: video.items.map((item) => ({
            ...item,
            localeId: item.locale,
            embeddedSubtitles: item.embedded_subtitles,
            customType: item.custom_type,
            imagePreview:
              video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
                ? CUSTOM_MODULE_IMAGE_PREVIEW
                : item.image_preview || '',
          })),
        }
      })
    } else {
      selectedTrainingVideo = [AUTOMATED_LEVEL_BASED_TRAINING]
    }

    return {
      ...state,
      campaign: {
        id: payload.data.id,
        participants: {
          ...state.campaign.participants,
          loader: true,
          included: payload.data.participants_choices || {},
          excluded: payload.data.participants_exclude_choices || {},
        },
        name,
        defaultLocaleId: payload.data.locale,
        timezone,
        status: payload.data.status,
        launchDate,
        launchTime,
        closeTime,
        sendRemindersUntil: payload.data.sendRemindersUntil,
        randomized: payload.data.randomized,
        randomizedScenarios: payload.data.randomized_scenarios,
        selectedTrainingVideo,
        otherModeSelection: [],
        playlistMode: isPlaylist ? PLAYLIST_MODES.PLAYLIST : PLAYLIST_MODES.SINGLE,
        messageStep: {
          fields: payload.data.training_campaign_data,
          validations: {},
        },
        saveMailSignature: payload.data.saveMailSignature,
        campaignTemplateId: payload.data.campaign_template,
        sendReminderEveryXBusinessDays: payload.data.sendReminderEveryXBusinessDays,
        sendCampaignSummaryToCampaignReportRecipients:
          payload.data.sendCampaignSummaryToCampaignReportRecipients,
        sendCompletionEmail: payload.data.sendCompletionEmail,
        trainingReminders: payload.data.trainingReminders,
        managerReportRemindersThreshold:
          payload.data.managerReportRemindersThreshold ||
          DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
        sendManagerReportEveryXDays: payload.data.sendManagerReportEveryXDays,
        managerReportDayOfWeek:
          payload.data.managerReportDayOfWeek || DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
        campaignManagerNotificationState: payload.data.managerNotificationState,
        managerNotificationBannerContent: payload.data.managerNotificationBanner?.text,
        managerReportEmailContentSubject: payload.data.managerReportEmail?.subject,
        managerReportEmailContent: payload.data.managerReportEmail?.body,
        triggerBasedCampaignData: payload.data.triggerBasedCampaignData,
        maxRemindersPerParticipant: payload.data.maxRemindersPerParticipant,
        completionNotificationSettings: mapCompletionNotificationSettingsFromApi(
          payload.data.completionNotificationSettings
        ),
      },
      validation: {
        ...state.validation,
        name: mapTrainingValidatorByName.name(name),
        launchDate: mapTrainingValidatorByName.launchDate(launchDate),
        closeTime: mapTrainingValidatorByName.closeTime(closeTime, launchDate),
        launchTime: mapTrainingValidatorByName.launchTime(
          launchTime,
          launchDate,
          timezone,
          randomized
        ),
      },
    }
  },
  [CHANGE_MESSAGE_STEP_PROPERTY]: (state, { payload }) => {
    const newValidations = {
      ...state.campaign.messageStep.validations,
    }
    const error = requiredValidation(payload.value)

    if (error) {
      newValidations[payload.propertyName] = requiredValidation(payload.value)
    } else {
      delete newValidations[payload.propertyName]
    }

    return {
      ...state,
      campaign: {
        ...state.campaign,
        messageStep: {
          fields: {
            ...state.campaign.messageStep.fields,
            [payload.propertyName]: payload.value,
          },
          validations: newValidations,
        },
      },
    }
  },
  [VALIDATE_MESSAGE_STEP_FIELDS]: (state) => {
    const newValidations = {}

    Object.keys(state.campaign.messageStep.fields).map((key) => {
      const error = requiredValidation(state.campaign.messageStep.fields[key])

      if (error) {
        newValidations[key] = error
      }
    })

    return {
      ...state,
      campaign: {
        ...state.campaign,
        messageStep: {
          ...state.campaign.messageStep,
          validations: newValidations,
        },
      },
    }
  },
  [GET_DEFAULT_TRAINING_DATA_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      messageStep: {
        ...state.campaign.messageStep,
        fields: {
          ...state.campaign.messageStep.fields,
          message: payload.data.message,
          subject: payload.data.subject,
          mailSignature: payload.data.mail_signature,
          fromEmail: payload.data.from_email,
        },
      },
    },
  }),
  [TOGGLE_TRAINING_VIDEO]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedTrainingVideo:
        state.campaign.playlistMode === PLAYLIST_MODES.PLAYLIST
          ? togglePlaylistVideo(state.campaign.selectedTrainingVideo, payload.trainingVideo)
          : payload.selected
            ? []
            : [payload.trainingVideo],
    },
  }),
  [REORDER_PLAYLIST_VIDEO_ASYNC.INITIATE]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      selectedTrainingVideo: movePlaylistVideo(
        state.campaign.selectedTrainingVideo,
        payload.from,
        payload.to
      ),
    },
  }),
  [SET_PLAYLIST_MODE_ASYNC.INITIATE]: (state, { payload }) => ({
    ...state,
    campaign: switchPlaylistMode(state.campaign, payload),
  }),
  [SYNC_PLAYLIST_REMINDERS_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      reminderDefaults: payload.nextDefaults,
      trainingReminders: replaceUneditedReminders(
        state.campaign.trainingReminders,
        payload.previousDefaults,
        payload.nextDefaults
      ),
    },
  }),
  [SYNC_PLAYLIST_ASSIGNMENT_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      messageStep: {
        ...state.campaign.messageStep,
        fields: {
          ...state.campaign.messageStep.fields,
          message: replaceUneditedMessage(
            state.campaign.messageStep.fields.message,
            payload.previousDefault,
            payload.nextDefault
          ),
        },
      },
    },
  }),
  [TOGGLE_SAVE_MAIL_SIGNATURE]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      saveMailSignature: payload.saveMailSignature,
    },
  }),
  [GET_EMAIL_PREVIEW_ASYNC.SUCCESS]: (state, { payload }) => ({
    ...state,
    campaign: {
      ...state.campaign,
      messageStep: {
        ...state.campaign.messageStep,
        fields: {
          ...state.campaign.messageStep.fields,
          subject: payload.data.response.subject,
        },
      },
    },
  }),
  DEFAULT: (state) => state,
}

const wizardCampaignReducer =
  () =>
  (
    state = {
      loader: false,
      error: null,
      validation: {},
      draftLoader: false,
      draftError: null,
      draftGotManaged: false,
      // workdays: 0 or 1, setting by PUT_WORKDAYS
      editMode: false, // might be changed by INIT_EDIT_MODE
      gotApproved: false, // once BE returning 200 for Approve becomes True and UI making redirect
      maxCampaignsAllowed: undefined,
      userProperties: {
        showQuickLaunchBTN: false,
        showQuickLaunchNotice: false,
        trainingContentVendors: [],
      },
      campaign: { ...DEFAULT_TRAINING_CAMPAIGN_OBJECT },
    },
    action
  ) => {
    const handle = wizardHandlers[action.type] || handlers[action.type] || handlers.DEFAULT

    return handle(state, action, CAMPAIGN_TYPES_VALUES.TRAINING)
  }

export default function () {
  return combineReducers({
    self: wizardCampaignReducer(),
    setupStep: setupStepReducer(),
    messageStep: messageStepReducer(),
    trainingModuleStep: trainingModuleStepReducer(),
    reviewAndLaunchStep: reviewAndLaunchStepReducer(),
  })
}
